import React from 'react';
import { Section, TextInput } from './ui';

const FIELDS = [
  ['cpu',         'Procesador (CPU)', 'AMD Ryzen 7 7445HS…'],
  ['gpu',         'GPU',              'RTX 4050…'],
  ['ram',         'Memoria RAM',      '16 GB DDR5…'],
  ['storage',     'Almacenamiento',   '512GB NVMe SSD…'],
  ['os',          'Sistema operativo','Windows 11 Home…'],
  ['screen_size', 'Pantalla',         '15.6"…'],
  ['condition',   'Condición',        'Nuevo / Reacondicionado…'],
  ['model_name',  'Modelo',           'Victus 15-fa1xxx…'],
];

export default function SpecsSection({ form, set }) {
  return (
    <Section title="Especificaciones técnicas">
      <div className="grid grid-cols-2 gap-x-6 gap-y-5">
        {FIELDS.map(([key, label, ph]) => (
          <TextInput key={key} label={label} placeholder={ph}
            value={form[key]} onChange={e => set(key, e.target.value)} />
        ))}
      </div>
    </Section>
  );
}
